const data = {
  HivKitCode: "tokens",
  CovidKitCode: "covid19",
  CommunityLinkProdURL: "https://www.community-link.health",
  CommunityLinkDevURL: "https://cl-dshbrd.map-test.plazus.com",
}

export default data;